import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { AuthService } from '../../core/auth/auth.service';

/** If already signed in as merchant, skip the login page. */
export const merchantLoginGuestGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  if (auth.isMerchantSession()) {
    return router.parseUrl('/campaigns');
  }
  return true;
};
